module.exports = __webpack_public_path__ + "img/bg_pattern_goals.debeb54b.png";